// import React from 'react';
// import { Button, Box, Card, styled, Container, CssBaseline, Typography } from '@mui/material';
// import { useNavigate } from 'react-router-dom';



// const Main = () => {
//     const navigate = useNavigate();
//     let id = 26;
//     const handleContinueClick = () => {
//         navigate(`/warehouse/${id}`);
//     };

//     return (
//         <Container component="main" maxWidth="sm" style={{ textAlign: 'center', marginTop: '150px' }}>
//             <CssBaseline />
//             <Card>
//                 <Box p={4}>
//                     <Typography variant="h4" component="h1" gutterBottom>
//                         Welcome to the PSW-POS
//                     </Typography>
//                     <Button variant="contained" color="primary" onClick={handleContinueClick}>
//                         Click to Continue
//                     </Button>
//                 </Box>
//             </Card>
//         </Container>
//     );
// }

// export default Main;

import React, { useState, useEffect } from 'react';
import { Box, Button, Card, Container, CssBaseline, FormGroup, Grid, TextField, Snackbar, CircularProgress } from '@mui/material';
import { AccountCircle, Https, Menu } from '@mui/icons-material';
import { useNavigate, useParams} from "react-router-dom";

import httpclient from '../../utils';
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const GridBlockContent = styled("div")(({ theme }) => ({
    display: "grid",
    maxWidth: "100%",
    gridTemplateColumns: "auto",
    gap: "1px solid #ccc",
    fontFamily: "'Trebechut' sans-serif",
    fontSize: "14px",
    fontWeight: "bold",
}));

const GridBlockTitle = styled("div")(({ theme }) => ({
    borderBottom: "1px solid #f1f1f1",
    backgroundColor: "#1976d2",
    color: "#ffffff",
    padding: "16px",
    fontSize: "16px",
    textAlign: "left",
}));

const Main = () => {
    const { id } = useParams();
    const navigate = useNavigate();
 
    const [open, setOpen] = useState(false);
    const [snackStatus, setSnackStatus] = useState("");
    const [snackMessage, setSnackMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [loginData, setLoginData] = useState({
        clientCode: "",
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        //console.log("user-name-value", name, value);
        setLoginData({
            ...loginData,
            [name]: value,
        });
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const handleKeyPassword = (e) => {
        if (e.key === "Enter") {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        setLoading(true);
        let formData = new FormData();
        formData.append("clientCode", loginData.clientCode);
        formData.append("email", loginData.email);
        formData.append("password", loginData.password);
        formData.append("warehouseID", id);

        httpclient.post('/erplyLogin', formData).then(({ data }) => {
            if (data.status === 200) {
                sessionStorage.setItem("token", JSON.stringify(data.token));
                sessionStorage.setItem("erplyLogin", 1)
                setOpen(true);
                setSnackStatus("success");
                setSnackMessage(data.message);
                setLoading(false);
                setTimeout(() => {
                    window.location = `/pos/warehouse/${id}`;
                }, 1000);
            } else {
                setLoading(false);
                setOpen(true);
                setSnackStatus("error");
                setSnackMessage(data.message);

            }
        })
    }



    return (
        <div>
            <Container component="main" maxWidth="lg" style={{ textAlign: 'center', marginTop: '120px' }}>
                <CssBaseline />
                <Card style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.5)' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormGroup>
                                <GridBlockContent>
                                    <GridBlockTitle>Login</GridBlockTitle>
                                    <Box pt={2} pb={1}>
                                        <Box p={2} pb={2} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <Menu sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField
                                                id="input-with-sx"
                                                label=""
                                                placeholder="Client Code"
                                                variant="standard"
                                                name="clientCode"
                                                type="text"
                                                value={loginData.clientCode}
                                                onChange={(e) => handleChange(e)}
                                                sx={{ width: '100%' }} />
                                        </Box>
                                        <Box p={2} pb={2} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField
                                                id="input-with-sx"
                                                label=""
                                                placeholder="Username"
                                                variant="standard"
                                                name="email"
                                                type="text"
                                                value={loginData.email}
                                                onChange={(e) => handleChange(e)}
                                                sx={{ width: '100%' }} />
                                        </Box>
                                        <Box p={2} pb={2} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <Https sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField
                                                id="input-with-sx"
                                                label=""
                                                placeholder="Password"
                                                variant="standard"
                                                name="password"
                                                type="password"
                                                value={loginData.password}
                                                onKeyDown={handleKeyPassword}
                                                onChange={(e) => handleChange(e)}
                                                sx={{ width: '100%' }} />
                                        </Box>
                                    </Box>
                                    <Box p={2} textAlign={"right"}>
                                        {loading ?
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                            >
                                                <CircularProgress style={{ height: "20px", width: "20px", color: "#fff", marginRight: "10px" }} /> Loading
                                            </Button> :
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={handleSubmit}
                                            >
                                                <b>Login</b>
                                            </Button>
                                        }
                                    </Box>
                                </GridBlockContent>
                            </FormGroup>
                        </Grid>
                    </Grid>
                </Card>
            </Container>
            
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={snackStatus}
                    sx={{ width: "100%" }}
                >
                    {snackMessage}
                </Alert>
            </Snackbar>
        </div >
    );
}

export default Main;



